import { render, staticRenderFns } from "./InformationCenter.vue?vue&type=template&id=1e471b8d&scoped=true&"
import script from "./InformationCenter.vue?vue&type=script&lang=js&"
export * from "./InformationCenter.vue?vue&type=script&lang=js&"
import style0 from "./InformationCenter.vue?vue&type=style&index=0&id=1e471b8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e471b8d",
  null
  
)

export default component.exports